import type { User } from '../types'

export const currentUser: User = {
  name: 'Ana Martins',
  firstName: 'Ana',
  username: '@ana.beelyv',
  avatar:
    'https://cdn.magicpatterns.com/patterns/generated-images/e26a3aad-10d9-4a25-b9d0-821d05a537d7.jpg',
  level: 3,
  totalXp: 168,
  streak: 12,
}
